module.exports = __webpack_public_path__ + "resources/img/img_watchall_nms1.903c5fbb575f0f5d4f7d4930f0792c0f.png";